
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import global_ from "./global"
import wx from 'weixin-js-sdk'

export default {
components: {Group, Selector, XTextarea, XButton, Cell},
data() {
return {
eduList: [{key: 'SUCCESS', value: '成功'}, {key: "FAIL", value: '失败'}],
result: 'SUCCESS',
iden: this.$route.params.role,
addition: '',
conclusion: '',
orderDetail: {},
imgList: [],
list: [],
showLoading: false,
appendix:[],
filename:''
}
},
methods: {
upload() {
var obj = {
photo: []
}

wx.chooseImage({
count: 1, // 默认9
sizeType: ['compressed'],
sourceType: ['album', 'camera'],
success: (res) => {
let localIds = res.localIds 
let upload = () => {
wx.uploadImage({
localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: (res) => {

this.$vux.loading.show()
obj.photo.push(res.serverId)
this.submitImage(obj)
},
fail: (error) => {
console.log(error)
}
})
}
upload()
},
fail: (error) => {
console.log(error)
}
})
},

removeFile(index) {
this.appendix=[];
this.list = [];
this.filename = '';
},

async choseFile() {
let fs;
let appendix = []

fs = this.$refs.file.files

this.$vux.loading.show({
text: 'Loading'
})
for (let i = 0; i < fs.length; i++) {
const formData = new FormData()
let d = fs[i]
if (d.size <= 1024 * 1024 * 100) {  //文件必须小于100M
formData.append("file", fs[i]);
const arr = d.name;
formData.append("name", arr);
const response = await this.$http.post('api/v1/photos/upload', formData)
appendix.push({origin: response.data.path, thumb: response.data.path});

this.filename = arr;
} else {
alert('上传文件过大！')
return false
}
}
this.$vux.loading.hide()

this.appendix = appendix;
this.list = appendix;

},

submitImage(userInfo) {
this.$http.post('/api/v1/photos/wechat', userInfo)
.then((response) => {
this.list.push(response.data[0]);
this.decrypt(response.data[0])
}).catch(error => {
if (error.response) {
if (error.response.data.error_message) {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
} else {
this.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
}
} else {
this.$vux.toast.show({
text: '服务器错误，请稍后重试',
type: 'cancel',
time: '1000'
})
}
})
},

decrypt(path) {
this.$http.get('api/v1/photos?path=' + path.thumb)
.then(res => {
this.imgList.push(res.data)
this.$vux.loading.hide()
})
},

fileDel() {
this.imgList = []
this.list = []
this.filename = '';
},

cancelResult() {
const that = this
if (this.orderDetail.userconfirm === '拒绝') {
this.$vux.confirm.show({
content: '如用户再次拒绝，将会进入仲裁流程',
theme: 'android',
onCancel() {

},
onConfirm() {
that.submit()
}
})
} else {
this.submit()
}
},

submit() {
this.showLoading = true
var header = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
if (this.result === 'FAIL') {
this.list = [];
}
if (this.list.length === 0 && this.conclusion.length < 20) {
alert('请详细描述维修结论，不少于20字')
this.showLoading = false
return
} else if (this.list.length !== 0 && this.conclusion.length <= 1) {
alert('请填写维修结论')
this.showLoading = false
return
}
if (!this.orderDetail.has_log){
alert('请补充维修日志')
return;
}
let newobj = {
role: this.iden,
result: this.result,
addition: this.addition,
conclusion: this.conclusion,
signature: {
version: '1.1',
content: [{path: this.list, describe:this.filename}]
}
}
console.log(this.orderDetail)
this.$http.put('/api/v1/normalrepairs/' + this.orderDetail.seq + '/result', newobj, header)
.then(res => {
this.$router.push({name: 'engineer'})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
this.showLoading = false
})
}
},
mounted() {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
app.$http.get('static/config.json').then(response => {
var config = response.data
if (isiOS) {
url = config.host + global_.entryUrl
} else {
url = config.host + app.$route.path
}
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then((response) => {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi'] 
})
wx.error(function (res) {
alert(res.errMsg)
})
})
.catch(function (error) {
alert('服务器错误，请稍后重试')
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
},
created() {
this.orderDetail = this.$route.params.obj
let opid = localStorage.getItem('userid');
var header = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
this.$http.get('/api/v1/accounts/' + opid, header)
.then((res) => {
for (let i = 0; i < res.data.length; i++) {
if (res.data[i].type === 'EXPT') {
this.iden = 'EXPT'
}
if (res.data[i].type === 'SRVP') {
this.iden = 'SRVP'
}
}
})
}
};



// WEBPACK FOOTER //
// ./src/components/finish.vue